import { UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class ModifiedErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: UntypedFormControl | null): boolean {
        return !!control && control.hasError('errors') && Array.isArray(control.getError('errors')) && control.getError('errors').length > 0;
    }
}
